<template>
  <v-menu
    :close-on-content-click="false"
    content-class="e-range-slider"
    min-width="272"
    right
    offset-y
  >
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot name="selection" />
      </div>
    </template>

    <v-card class="px-5 pt-4 pb-7">
      <v-layout column>
        <h6 class="mb-5 text-h6">
          {{ title }}
        </h6>
        <v-layout class="align-center">
          <v-text-field
            :value="range[0]"
            :prefix="prefix"
            class="flex-0-0 text-body-2"
            dense
            hide-details
            outlined
            style="width: 105px"
            type="number"
            @change="updateRange(0, $event)"
          />
          <v-divider />
          <v-text-field
            :value="range[1]"
            :prefix="prefix"
            class="flex-0-0 text-body-2"
            dense
            hide-details
            outlined
            style="width: 105px"
            type="number"
            @change="updateRange(1, $event)"
          />
        </v-layout>
        <v-layout class="mt-6">
          <span class="text-body-2 grey--text text--darken-1">{{ prefix }}{{ min }}</span>
          <v-spacer />
          <span class="text-body-2 grey--text text--darken-1">{{ prefix }}{{ max }}</span>
        </v-layout>
        <v-range-slider
          v-model="range"
          :max="max"
          :min="min"
          hide-details
          class="align-center"
          @change="change"
        />
      </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ERangeSlider',

  props: {
    title: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    range: [0, 0]
  }),

  methods: {
    change() {
      this.$emit('change', this.range)
    },
    updateRange(rIdx, value) {
      this.$set(this.range, rIdx, value)
      this.change()
    }
  }
}
</script>

<style lang="scss">
.e-range-slider {
  .v-slider--horizontal {
    min-height: 20px;
  }
}
</style>
